"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PressReleaseCard = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _basicStyledText = _interopRequireDefault(require("../basicStyledText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PressReleaseCard = props => {
  const {
    id,
    title,
    author,
    paragraph,
    feature_img
  } = props;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "con-press-card",
    id: "press-release-".concat(id)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-press-image__container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "con-press-image__src",
    src: feature_img
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-press-text"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "con-heading__m"
  }, title), /*#__PURE__*/_react.default.createElement("h4", {
    className: "con-text__xs--bold"
  }, author), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text__xs--margin-bottom-2"
  }, /*#__PURE__*/_react.default.createElement(_basicStyledText.default, {
    item: paragraph
  })), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "".concat(id),
    className: "con-text__xs--bold"
  }, " Read more")));
};
exports.PressReleaseCard = PressReleaseCard;
PressReleaseCard.propTypes = {
  id: _propTypes.default.string,
  author: _propTypes.default.string,
  feature_img: _propTypes.default.string,
  title: _propTypes.default.string,
  paragraph: _propTypes.default.object
};